var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.variant.id == 'Account Creation')?_c('EligibilityTPA'):_c('EligibilityTPB')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }